export default __webpack_public_path__ + "static/media/5ccfeabe485c8a75e7f48985162f8c211581618978902.3c8ff8fd.webp";